import List from '@/views/app/ManualCastrations'
import Show from '@/views/app/ManualCastrations/Show'
import Form from '@/views/app/ManualCastrations/Form'
import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'

function ManualCastrationsRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
        <Route path={path} exact>
          <List title="Petis - Parceiros / Castrações manuais" />
        </Route>
        <Route exact path={`${path}/add`}>
          <Form title="Petis - Parceiros / Castrações manuais / Adicionar" />
        </Route>
        <Route exact path={`${path}/show/:id`}>
          <Show title="Petis - Parceiros / Castrações manuais / Exibir" />
        </Route>
    </div>
  )
}

export default ManualCastrationsRoutes
